export async function runWellheadDetection({ scope, fetchWithAuth, projectId, aoiId, datasetId }) {
  const body = {
    action_id: 'wellhead_detection',
    scope: scopeToServerShape(scope, aoiId),
    project_id: projectId ?? null,
    dataset_id: datasetId ?? null,
  };

  const response = await fetchWithAuth('/api/v1/jobs', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    let detail = `Server error ${response.status}`;
    try {
      const err = await response.json();
      if (err?.error) detail = err.error;
    } catch { /* */ }
    throw new Error(detail);
  }

  const data = await response.json();
  if (data.status === 'failed') {
    throw new Error(data.error ?? 'Job failed to start');
  }

  return {
    jobId: data.job_id,
    externalJobId: data.external_job_id,
    tileCount: data.tile_count,
    status: data.status,
  };
}

export async function getWellheadDetectionScopeCount({ scope, fetchWithAuth }) {
  const response = await fetchWithAuth(
    `/api/v1/datasets/for-scope?${scopeToQueryString(scope)}&type=imagery&limit=1`
  );
  if (!response.ok) throw new Error(`Count failed (${response.status})`);
  const data = await response.json();
  const dataset = data.datasets?.[0];
  return dataset?.intersecting_granules ?? 0;
}

// Entitled imagery sources that intersect the scope, for the run pulldown.
// Same endpoint as the count — entitlement- and coverage-scoped to the
// effective org (X-Active-Org via fetchWithAuth). Returns only datasets with
// at least one intersecting granule, newest-first.
export async function fetchEntitledImagery({ scope, fetchWithAuth }) {
  const response = await fetchWithAuth(
    `/api/v1/datasets/for-scope?${scopeToQueryString(scope)}&type=imagery&limit=100`
  );
  if (!response.ok) throw new Error(`Imagery lookup failed (${response.status})`);
  const data = await response.json();
  return (data.datasets ?? []).filter((d) => (d.intersecting_granules ?? 0) > 0);
}

function scopeToServerShape(scope, aoiId) {
  if (scope.kind === 'aoi') {
    return { kind: 'aoi', aoi_id: aoiId ?? scope.aoi?.id ?? null, aoi_geom: scope.aoi.geom };
  }
  if (scope.kind === 'viewport') {
    return { kind: 'viewport', bbox: scope.bbox };
  }
  throw new Error(`Unknown scope kind: ${scope.kind}`);
}

function scopeToQueryString(scope) {
  if (scope.kind === 'aoi') {
    return `aoi_geom=${encodeURIComponent(JSON.stringify(scope.aoi.geom))}`;
  }
  return `bbox=${encodeURIComponent(scope.bbox)}`;
}
